import { PostHogProvider } from "@/components/posthog-provider";
import { QueryProvider } from "@/query";
import { DataPrefetchProvider } from "@/query/providers/DataPrefetchProvider";
import { usesMobileApp } from "@/lib/mobile-app";
import { Toaster } from "sonner";
import { useEffect, useState } from "react";

export default function Providers({ children }: { children: React.ReactNode }) {
  // Synchronous initial value (not a post-mount effect): a toast fired during
  // the first render must already be top-positioned on mobile, never covering
  // the bottom-docked chat composer. usesMobileApp() also covers the Capacitor
  // build regardless of viewport width (e.g. tablets ≥ 768px).
  const [isMobile, setIsMobile] = useState(
    () => usesMobileApp() || window.innerWidth < 768,
  );

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(usesMobileApp() || window.innerWidth < 768);
    };

    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Offline-first sync (AISyncProvider) is mounted in PageContent so it only
  // boots on authenticated routes — landing/auth/superadmin pages don't need
  // the Dexie cache or SSE connection.
  return (
    <PostHogProvider>
      <QueryProvider>
        <DataPrefetchProvider>{children}</DataPrefetchProvider>
        <Toaster
          // Top on mobile: the Agent app's composer + bottom nav own the bottom
          // edge, so a bottom-center toast covered the text input. Desktop keeps
          // bottom-left where there's no bottom chrome.
          position={isMobile ? "top-center" : "bottom-left"}
          richColors
          closeButton
          toastOptions={{
            duration: 4000,
            className: "font-sans",
          }}
        />
      </QueryProvider>
    </PostHogProvider>
  );
}
